export default __webpack_public_path__ + "static/media/gift.dfe47f48.svg";